import React from 'react';
import './App.css';
import NewData from './components/NewData';

function App() {
    return (
        <>
            <NewData />
        </>
    );
}

export default App;
